import { Alert } from '@material-ui/lab';

import { useDialogContext } from './context';

export const SubmitError = () => {
  const { error } = useDialogContext();
  if (!error) return null;
  return <Alert severity="error">{error.message}</Alert>;
};

SubmitError.displayName = 'DialogComposite.SubmitError';

export default SubmitError;
